// 表格自定义KEY标识，不可重复
export const tableColumnsKeys = {
  reverseRefundList: 'fwsReverseRefundList', // 逆向订单-退款记录
  reverseSupplementList: 'fwsReverseSupplementList', // 逆向订单-补款记录
  approvalRefundList: 'fwsApprovalRefundList', // 会计审核-退款审核
  approvalSupplementList: 'fwsApprovalSupplementList', // 会计审核-补款审核
};
